// extracted by mini-css-extract-plugin
export default {"wrap":"IFkcyWdYCdWR23p1aHPw"};